/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Lifecycle status of an appointment slot.
 */
export type SlotStatus = (typeof SlotStatus)[keyof typeof SlotStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SlotStatus = {
  planned: 'planned',
  available: 'available',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;
